import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import Moment from 'react-moment';
import Typography from '@mui/material/Typography';
import StarIcon from '@mui/icons-material/Star';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ErrorIcon from '@mui/icons-material/Error';

import classes from './NotifictionItem.module.css';

const NotificationItem = props => {
  return (
    <ListItem
      className={classes.notificationItem}
      button
      component="a"
      href={props.notif.action}
      target="_blank"
    >
      {props.notif.icon == 'stars' ? (
        <StarIcon className={classes.iconNotificationUser} />
      ) : props.notif.icon == 'chrome_reader_mode' ? (
        <ChromeReaderModeIcon
          className={classes.iconNotificationUser}
        />
      ) : props.notif.icon == 'add_shopping_cart' ? (
        <AddShoppingCartIcon
          className={classes.iconNotificationUser}
        />
      ) : props.notif.icon == 'error' ? (
        <ErrorIcon className={classes.iconNotificationUser} />
      ) : (
        ''
      )}
      <div className={classes.contentTitle}>
        <div className={classes.titleBox}>
          <Typography
            variant="subheading"
            className={classes.itemNotiCategory}
            gutterBottom
          >
            {props.notif.category}
          </Typography>
          <Moment
            className={classes.itemNotiTime}
            format="DD/MM/YYYY HH:mm"
            unix
          >
            {parseInt(props.notif.created / 1000)}
          </Moment>
        </div>
        <div className={classes.subtitleBox}>
          <Typography
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: props.notif.message
            }}
            gutterBottom
            className={classes.textNoti}
          />
        </div>
      </div>
    </ListItem>
  );
};

NotificationItem.propTypes = {
  // eslint-disable-next-line react/require-default-props
  notif: PropTypes.obj
};

export default NotificationItem;
